import React from 'react'
import { motion } from 'framer-motion'
import { ebookStore } from '../store/ebookStore'

const TableOfContents = ({ chapters, onSelectChapter }) => {
  const { readingProgress } = ebookStore()

  return (
    <div className="toc-container">
      <motion.div 
        className="toc-header"
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
      >
        <h2 className="toc-title">Contenido</h2>
        <p className="toc-subtitle">Elige un capítulo para comenzar tu viaje</p>
      </motion.div>

      <div className="chapters-list">
        {chapters.map((chapter, index) => (
          <motion.div
            key={chapter.id}
            className="chapter-item"
            initial={{ opacity: 0, x: -30 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.5, delay: index * 0.1 }}
            whileHover={{ x: 10, backgroundColor: 'rgba(255, 255, 255, 0.1)' }}
            onClick={() => onSelectChapter(index)}
          >
            <div className="chapter-number">
              <span className="number">{String(index + 1).padStart(2, '0')}</span>
              <div className="progress-ring">
                <svg viewBox="0 0 36 36">
                  <path
                    d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"
                    fill="none"
                    stroke="rgba(255,255,255,0.1)"
                    strokeWidth="2"
                  />
                  <path
                    d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"
                    fill="none"
                    stroke="#4ade80"
                    strokeWidth="2"
                    strokeDasharray={`${readingProgress[chapter.id] || 0}, 100`}
                    strokeLinecap="round"
                  />
                </svg>
              </div>
            </div>

            <div className="chapter-info">
              <h3 className="chapter-title">{chapter.title}</h3>
              <div className="chapter-meta">
                {chapter.hasAudio && (
                  <span className="audio-badge">
                    <span className="audio-icon">🎧</span>
                    Audio guiado
                  </span>
                )}
                {readingProgress[chapter.id] && (
                  <span className="progress-badge">
                    {readingProgress[chapter.id]}% completado
                  </span>
                )}
              </div>
            </div>

            <div className="chapter-arrow">
              <span>→</span>
            </div>
          </motion.div>
        ))}
      </div>

      <motion.div 
        className="toc-footer"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 1, duration: 0.6 }}
      >
        <div className="progress-summary">
          <span className="progress-label">Progreso total:</span>
          <div className="progress-bar">
            <motion.div 
              className="progress-fill"
              initial={{ width: 0 }}
              animate={{ width: `${Object.values(readingProgress).reduce((a, b) => a + b, 0) / chapters.length || 0}%` }}
              transition={{ duration: 1, delay: 1.2 }}
            />
          </div>
          <span className="progress-percentage">
            {Math.round(Object.values(readingProgress).reduce((a, b) => a + b, 0) / chapters.length || 0)}%
          </span>
        </div>
      </motion.div>
    </div>
  )
}

export default TableOfContents
